import QueryString from 'query-string';
import Storage from './storage.service';

/**
 * Generate query params string of object and insert the `?` symbol
 * @param params - Object
 */
const query = params => (params ? `?${QueryString.stringify(params)}` : '');

/**
 * Generate query params and utms params
 * @param params - Object
 * @returns - String
 */
const external = params => {
    const { utms } = Storage.get({ key: Storage.keys.config }) || {};
    return query({ ...params, ...(utms || {}) });
};

export default {
    parse: QueryString.parse,
    stringify: QueryString.stringify,
    parseUrl: QueryString.parseUrl,
    query,
    external,
};
